import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionAnalyzeLegacyUserForAccount(
    $input: AnalyzeLegacyUserForAccountInput!
  ) {
    actionAnalyzeLegacyUserForAccount(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      analysisData
    }
  }
  ${ErrorMessageInfo}
`;
